import React from "react";
import { PosCustomButton } from "../../../../../../customComponents/PosCustomButton/PosCustomButton";
import "./AppliedDiscountCard.css";

const getDiscountText = (discountType, amount) => {
  const formattedAmount = Number(amount || 0).toFixed(2);

  if (discountType === "PERCENTAGE") {
    return `Order percentage discount applied: Rs ${formattedAmount}`;
  }

  if (discountType === "FLAT_OFF") {
    return `Order flat discount applied: Rs ${formattedAmount}`;
  }

  return `Order discount applied: Rs ${formattedAmount}`;
};

export default function AppliedDiscountCard({
  amount = 0,
  discountType = "NONE",
  onRemove,
  loading = false,
  locked = false,
}) {
  if (!(Number(amount) > 0)) return null;

  return (
    <div className="applied-discount-wrapper">
      <div className="applied-discount-inner-wrapper">
        <div className="applied-discount-box">
          <div className="applied-discount-left">
            <div className="applied-discount-checkmark">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="20,6 9,17 4,12"></polyline>
              </svg>
            </div>
            <span className="applied-discount-text">{getDiscountText(discountType, amount)}</span>
          </div>

          {!locked && (
            <PosCustomButton
              variant="red-d"
              loading={loading}
              title="Remove"
              onClickFunction={onRemove}
            />
          )}
        </div>
      </div>
    </div>
  );
}
